import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";

const curriculumData = [
  {
    title: "Digital Marketing Foundations & Online Branding",
    description:
      "What is digital marketing & how it works, Understanding online consumer behavior, Brand positioning in the digital world, Channels: SEO SEM SMM Email Content, Crafting holistic marketing strategies",
  },
  {
    title: "Search Engine Optimization (SEO) & Website Ranking",
    description:
      "How search engines work, Keyword research & competitor analysis, On-page SEO: titles meta tags content optimization, Off-page SEO: backlinks authority building, Technical SEO & SEO tools (Google Search Console Ahrefs SEMrush)",
  },
  {
    title: "Content Creation, Copywriting & Social Media Strategy",
    description:
      "Creating engaging content for different platforms, Writing persuasive ad copy & captions, Content pillars & content calendar planning, Viral content strategies, Brand voice & storytelling",
  },
  {
    title: "Social Media Marketing (SMM) for Engagement & Growth",
    description:
      "Instagram Facebook LinkedIn YouTube fundamentals, Reels stories carousels & long-form content, Community building strategies, Influencer marketing & collaborations, Measuring engagement & growth analytics",
  },
  {
    title: "Search Engine Marketing (SEM) & Paid Ads Mastery",
    description:
      "Google Ads & YouTube Ads, Setting up PPC campaigns, Keyword bidding strategies, Retargeting & remarketing techniques, Creating high-converting ad creatives",
  },
  {
    title: "Email Marketing & Automation Workflows",
    description:
      "Building email lists ethically, Writing high-performing email sequences, Drip campaigns & audience segmentation, A/B testing & automation tools (Mailchimp Sendinblue), KPI tracking & optimization",
  },
  {
    title: "Analytics, Reporting & Performance Optimization",
    description:
      "Google Analytics & insights interpretation, Understanding traffic conversions & user behavior, Creating dashboards & reports, Identifying drop-offs & improving funnels, Data-driven decision making",
  },
  {
    title: "E-commerce Marketing & Conversion Optimization",
    description:
      "Product page SEO, Online store optimization (Shopify WooCommerce), Upselling & cross-selling techniques, Shopping ads & catalog management, CRO (Conversion Rate Optimization) techniques",
  },
  {
    title: "Brand Building, ORM & Digital PR",
    description:
      "Online reputation management, Handling negative reviews & feedback, Creating viral brand identity systems, Press releases blogs & digital PR, Building long-term brand trust",
  },
  {
    title: "Capstone Digital Marketing Project & Career Launchpad",
    description:
      "Creating real campaigns: SEO + SMM + Ads, Building a digital marketing portfolio, Case studies on brand campaigns, Resume building for digital roles, Interview prep: DM strategist SMM manager SEO analyst",
  },
];

const ProgramCurriculum = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleSection = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="curriculum-container">
      <motion.h2
        className="curriculum-heading"
        initial={{ opacity: 0, y: -30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        Program Curriculum
      </motion.h2>
      <motion.p
        className="curriculum-subtext"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.6 }}
      >
        This curriculum is structured in a practical and progressive format so
        you can learn step-by-step from zero to advanced level — and build
        real-world applications.
      </motion.p>
      <div className="curriculum-list">
        {curriculumData.map((item, index) => (
          <motion.div
            key={index}
            className="curriculum-item"
            onClick={() => toggleSection(index)}
            whileHover={{ x: 10 }}
            transition={{ duration: 0.3 }}
          >
            <div className="title-row">
              <span className="curriculum-title">{item.title}</span>
              <motion.span
                animate={{ rotate: activeIndex === index ? 90 : 0 }}
                transition={{ duration: 0.3 }}
                className="arrow"
              >
                ➤
              </motion.span>
            </div>
            <AnimatePresence>
              {activeIndex === index && (
                <motion.p
                  className="curriculum-description"
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: "auto" }}
                  exit={{ opacity: 0, height: 0 }}
                  transition={{ duration: 0.4 }}
                >
                  {item.description}
                </motion.p>
              )}
            </AnimatePresence>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default ProgramCurriculum;
